import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <CardsSection />
        <AboutSection />
        <CommentsSection />
        <TopicsSection />
        <MediaSection />
        <ContactSection />
        <RankingSection />
        <AppSection />
        <UpdatesSection />
        <CarouselSection />
        <IndexSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}